// extracted by mini-css-extract-plugin
module.exports = {"Tags__list":"Fh8b","Tags__item":"mjXz"};